import { Injectable } from '@angular/core';
import { getAltair2Api } from '../utils/api/openapi-utils';
import { GetLoginNextStep200ResponseStatusEnum, GetLoginNextStep200ResponseTypeEnum } from '../generated/api/altair2';
@Injectable({
  providedIn: 'root'
})
export class LoginService {
  
  public async getLoginNextStep(email:string): Promise<{type?:AccountType,status:AccountStatus}> {
    const api = await getAltair2Api(false);
    const response = await api.getLoginNextStep({
      email: email
    });

    return {type:response.type,status:response.status};
  }  
}
export type AccountStatus = GetLoginNextStep200ResponseStatusEnum;
export type AccountType = GetLoginNextStep200ResponseTypeEnum;